<template>
    <div></div>
</template>

<script>
import { events } from "../events";
import { TYPE } from "vue-toastification";

export default {
    name: "Toaster",
    created() {
        events.$on("toastify", (value) => {
            this.notify(value);
        });

        events.$on('notificationSuccess', (content) => {
            this.$toast(content,{type: TYPE.SUCCESS})
        })

        events.$on('notificationFailure', (content) => {
            this.$toast(content,{type: TYPE.ERROR})
        })
    },
    methods: {
        async notify(error) {
            let status = error.response.status;

            switch (status) {
                case 401:
                    this.$toast(this.$t("error.invalid_credentials"), {
                        type: TYPE.WARNING,
                    });

                    await this.$router.push({ name: "Login" });
                    break;
                case 403:
                    this.$toast(this.$t("error.forbidden"), {
                        type: TYPE.WARNING,
                    });
                    break;
                case 405:
                    this.$toast(this.$t("error.impossible"), {
                        type: TYPE.ERROR,
                    });
                    break;
                case 500:
                    this.$toast(this.$t("error.server"), {
                        type: TYPE.ERROR,
                    });
                    break;
                case 422:
                    this.$toast(
                        error.response.data.message,
                        {
                            type: TYPE.WARNING,
                        }
                    );
            }
        },
    },
};
</script>
